import { NumberBox } from "devextreme-react";
import type { INumberBoxOptions, NumberBoxRef } from "devextreme-react/number-box";
import { FocusInEvent } from "devextreme/ui/number_box";
import { type Ref, forwardRef } from "react";

const NumberBoxWrapper = forwardRef(
  (props: INumberBoxOptions, ref: Ref<NumberBoxRef> | undefined) => (
    <NumberBox
      {...props}
      ref={ref}
      step={0}
      onFocusIn={(e: FocusInEvent) => {
        const inputEl: HTMLInputElement | null = e.element.querySelector(".dx-texteditor-input");
        if (!inputEl) return;
        inputEl.selectionStart = 0;
        inputEl.selectionEnd = inputEl.value.length;
        props.onFocusIn;
      }}
    />
  )
);
export default NumberBoxWrapper;
